import { docodeHexResponse } from '../../_common/common.utils';
import memberDetailsReportTypes from './member-details-report.type';

const INITIAL_STATE = {
	fetchMemberDetailsResponse: null,
	fetchMemberDetailsArr: [],
};

const memberDetailsReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		case memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_SUCCESS:
			return {
				...state,
				fetchMemberDetailsResponse: action.payload,
				fetchMemberDetailsArr: docodeHexResponse(
					action.payload,
					'PostAllMemberDetailReportKey',
				),
			};

		case memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_FAILURE:
			return {
				...state,
				fetchMemberDetailsResponse: action.payload,
				fetchMemberDetailsArr: [],
			};

		case memberDetailsReportTypes.FETCH_MEMBER_DETAILS_REPORT_RESPONSE_CHANGED:
			return { ...state, fetchMemberDetailsResponse: null };

		default:
			return state;
	}
};

export default memberDetailsReportReducer;
